import { render } from "./EMployeeRejectedLiquidations.vue?vue&type=template&id=b59076c8"
import script from "./EMployeeRejectedLiquidations.vue?vue&type=script&lang=js"
export * from "./EMployeeRejectedLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__